import { render, staticRenderFns } from "./VoorhoedeAccordion.vue?vue&type=template&id=80802de0&"
import script from "./VoorhoedeAccordion.vue?vue&type=script&lang=js&"
export * from "./VoorhoedeAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports